
import { Outlet, Link } from 'react-router-dom';
import { apiService } from '../../../services';
import { LoginTile, Footer } from '../../';
import { Header, Notifications } from '../../';
import { ToastContainer } from 'react-toastify';
import i18n from "../../../i18n";
import { useHeroItems } from '../../../modules';

import SocialIntentsChat from '../../Chat/SocialIntentsChat.component';

const isLoggedIn = apiService.instance.isLoggedIn();


export default function ZebraLayout() {
    const {
        HeroFeed
    } = useHeroItems();

    const t = i18n.t;
    return (<>
        {isLoggedIn ? (
            <>
                <Notifications />
                <ToastContainer autoClose={false} closeOnClick />
                <Header />
                <Outlet />
                <Footer />
                <SocialIntentsChat />
            </>
        ) : (
            <>
                <LoginTile />
            </>
        )}
    </>
    );

}